var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m120.5,70.92v43.75H16.48v-43.75H1.98v58.25h133.03v-58.25h-14.51Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.98,1.83v55.66h14.5V16.33h104.02v41.15h14.51V1.83H1.98Z",
    style: {
      fill: "#d65e38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m68.49,33.22c-17.98,0-32.61,14.63-32.61,32.62s14.63,32.62,32.61,32.62,32.62-14.64,32.62-32.62-14.63-32.62-32.62-32.62Zm0,50.73c-9.98,0-18.11-8.12-18.11-18.11s8.13-18.12,18.11-18.12,18.12,8.13,18.12,18.12-8.13,18.11-18.12,18.11Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.28,23.38c-2.93,0-5.31,2.38-5.31,5.31s2.38,5.31,5.31,5.31,5.31-2.38,5.31-5.31-2.38-5.31-5.31-5.31Z",
    style: {
      fill: "#d65e38"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramOrange);
export default __webpack_public_path__ + "static/media/Instagram.Orange.583268c1505f2fb6c5a7ee19897b645f.svg";
export { ForwardRef as ReactComponent };